// extracted by mini-css-extract-plugin
module.exports = {"container":"base-info-container__1f4ky"};